import { useRef, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase-config";
import "./LoginComponent.css"; // Import CSS file
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/userSlice";
import Backend from "../layout/backend/Backend";

function LoginComponent() {
  const registerEmail = useRef("");
  const registerPassword = useRef("");
  const loginEmail = useRef("");
  const loginPassword = useRef("");
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.userData);
  const [user, setUser] = useState({});
  console.log(isAdmin);
  // Listen for authentication state changes
  onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser);
  });

  const handleLogin = async () => {
    try {
      const loggedInUser = await signInWithEmailAndPassword(
        auth,
        loginEmail.current.value,
        loginPassword.current.value
      );
      dispatch(userActions.logInOut());
      // Clear input fields after successful login
      loginEmail.current.value = "";
      loginPassword.current.value = "";
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      dispatch(userActions.logInOut());
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      {isAdmin ? (
        <>
          {user?.email && (
            <p>
              {" "}
              <h4>User Logged In:</h4>
              {user.email}
            </p>
          )}
          <button onClick={handleLogout}>Sign Out</button>
          {isAdmin && <Backend />}
        </>
      ) : (
        <>
          <div className="login-container">
            <h3>Login</h3>
            <input type="email" placeholder="Email..." ref={loginEmail} />
            <input
              type="password"
              placeholder="Password..."
              ref={loginPassword}
            />
            <button onClick={handleLogin}>Login</button>
          </div>
        </>
      )}
    </>
  );
}

export default LoginComponent;
